export class DebugLog {
  constructor(enabled = false) {
    this.enabled = enabled;
  }

  log(...args) {
    if (this.enabled) console.log("[DwMap:Debug]", ...args);
  }

  warn(...args) {
    if (this.enabled) console.warn("[DwMap:Debug]", ...args);
  }

  attachTo(map, tileLayer) {
    if (!this.enabled) return;

    if (map) {
      map.on("zoomend", () => this.log("Zoom changed →", map.getZoom()));
      map.on("moveend", () => this.log("Map moved →", map.getCenter()));
      //map.on("layeradd", (e) => this.log("Layer added:", e.layer));
      //map.on("layerremove", (e) => this.log("Layer removed:", e.layer));
    }

    if (tileLayer) {
      tileLayer.on("tileerror", (e) => this.warn("Tile error:", e.tile.src));
    }

    this.log("DebugLog attached.");
  }
}
